import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Hr/reports/AttendanceReport/HumanCapitalReportAttendanceAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class HumanCapitalReportAttendanceActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Hr/reports/AttendanceReport/HumanCapitalReportAttendance")
	}

	render() {
		return (
			<Activity 
				name="HumanCapitalReportAttendance"
				RenderedComponent={this.RenderedComponent}
				context="HumanCapitalReportAttendance"
				action="HumanCapitalReportAttendance"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(HumanCapitalReportAttendanceActivity)
